/* Aura theme — explorer, AJAX cart, FAQ, nav, reveals. */
(function () {
  'use strict';
  var $ = function (id) { return document.getElementById(id); };
  var money = function (cents) {
    var s = window.AURA && AURA.moneyFormat ? AURA.moneyFormat : '${{amount}}';
    var amt = (cents / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    var amtNoDec = Math.round(cents / 100).toLocaleString('en');
    return s.replace(/\{\{\s*amount\s*\}\}/g, amt)
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amtNoDec)
            .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amt.replace('.', ','))
            .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amtNoDec);
  };

  /* ---------------- ambient aura ---------------- */
  var aura = $('aura');
  if (aura && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var tx = 50, ty = 30, cx = 50, cy = 30;
    addEventListener('pointermove', function (e) {
      tx = e.clientX / innerWidth * 100; ty = e.clientY / innerHeight * 100;
    }, { passive: true });
    (function loop() {
      cx += (tx - cx) * 0.045; cy += (ty - cy) * 0.045;
      aura.style.setProperty('--mx', cx.toFixed(2) + '%');
      aura.style.setProperty('--my', cy.toFixed(2) + '%');
      requestAnimationFrame(loop);
    })();
  }

  /* ---------------- toast ---------------- */
  var toastTimer;
  function toast(msg) {
    var t = $('toast'); if (!t) return;
    t.textContent = msg; t.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('on'); }, 2400);
  }

  /* ---------------- cart drawer ---------------- */
  function openCart(on) {
    var d = $('drawer'), s = $('scrim');
    if (!d) return;
    d.classList.toggle('on', on);
    if (s) s.classList.toggle('on', on);
    d.setAttribute('aria-hidden', String(!on));
    document.body.style.overflow = on ? 'hidden' : '';
  }

  function renderCart(cart) {
    var body = $('cartBody'), count = $('cartCount'), total = $('cartTotal');
    if (count) count.textContent = cart.item_count;
    if (total) total.textContent = money(cart.total_price);
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<p class="empty">Nothing here yet.<br>Pick a program and it\u2019ll show up.</p>';
      return;
    }
    body.innerHTML = cart.items.map(function (it) {
      var img = it.image
        ? '<img class="li-thumb" src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') +
          '" alt="" width="46" height="60">'
        : '<div class="li-thumb"></div>';
      return '<div class="line-item">' + img +
        '<div class="li-main"><strong>' + it.product_title + '</strong>' +
        '<small>' + (it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '') + '</small>' +
        '<a class="li-remove" href="#" data-rm="' + it.key + '">Remove</a></div>' +
        '<div style="font-weight:600">' + money(it.final_line_price) + '</div></div>';
    }).join('');
  }

  function fetchCart() {
    return fetch(window.AURA.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderCart(c); return c; });
  }

  function addToCart(id, qty) {
    return fetch(window.AURA.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Could not add that.');
        return data;
      });
    });
  }

  function changeLine(key, qty) {
    return fetch(window.AURA.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-cart-open]');
    if (open) { e.preventDefault(); openCart(true); fetchCart(); return; }
    if (e.target.closest('[data-cart-close]')) { openCart(false); return; }

    var rm = e.target.closest('[data-rm]');
    if (rm) { e.preventDefault(); changeLine(rm.dataset.rm, 0); return; }

    var add = e.target.closest('[data-add]');
    if (add) {
      e.preventDefault();
      var id = add.dataset.add;
      if (!id || id === 'none') {
        toast('Link this program to a product in the theme editor.');
        return;
      }
      var label = add.textContent;
      add.disabled = true; add.textContent = 'Adding\u2026';
      addToCart(id, 1)
        .then(function () { return fetchCart(); })
        .then(function () { toast(add.dataset.addName || 'Added to cart'); openCart(true); })
        .catch(function (err) { toast(err.message); })
        .then(function () { add.disabled = false; add.textContent = label; });
    }
  });

  addEventListener('keydown', function (e) { if (e.key === 'Escape') openCart(false); });

  var checkout = $('checkout');
  if (checkout) checkout.addEventListener('click', function () {
    window.location.href = window.AURA.routes.checkout;
  });

  if ($('cartBody')) fetchCart();

  /* ---------------- program explorer ---------------- */
  var explorer = document.querySelector('[data-explorer]');
  if (explorer && window.AURA_CONTENT) {
    var CONTENT = window.AURA_CONTENT;
    var LINKS = (window.AURA && AURA.programs) || {};
    var keys = Object.keys(CONTENT).filter(function (k) { return CONTENT[k]; });
    var current = explorer.dataset.start && CONTENT[explorer.dataset.start]
      ? explorer.dataset.start : keys[0];
    var currentDay = 1;
    var tabsEl = explorer.querySelector('[data-tabs]');
    var weeksEl = explorer.querySelector('[data-weeks]');
    var pageEl = explorer.querySelector('[data-page]');

    if (tabsEl) {
      tabsEl.innerHTML = keys.map(function (k) {
        return '<button class="tab' + (k === current ? ' on' : '') + '" role="tab" data-prog="' + k + '">' +
          CONTENT[k].name + '</button>';
      }).join('');
    }

    function renderWeeks() {
      var prog = CONTENT[current];
      weeksEl.innerHTML = prog.weeks.map(function (w) {
        var cells = '';
        for (var n = w.from; n <= w.to; n++) {
          var cls = 'day' + (n <= 3 ? ' free' : ' lock') + (n === currentDay ? ' on' : '');
          cells += '<button class="' + cls + '" data-day="' + n + '" aria-label="Day ' + n + '">' +
            String(n).padStart(2, '0') + '</button>';
        }
        return '<div class="week-row"><div class="week-meta">' +
          '<span class="wk">' + w.label + '</span><span class="wt">' + w.title + '</span></div>' +
          '<div class="week-days">' + cells + '</div></div>';
      }).join('');
    }

    function renderPage() {
      var prog = CONTENT[current];
      var day = prog.days.filter(function (d) { return d.n === currentDay; })[0];
      var num = String(currentDay).padStart(2, '0');
      var chrome = '<div class="page-chrome"><span>Aura</span><span>' + prog.name + '</span></div>';
      var inner;

      if (day.c) {
        var body = '', openList = false;
        day.c.forEach(function (b) {
          if (b.k === 'b') {
            if (!openList) { body += '<ul>'; openList = true; }
            body += '<li>' + b.v + '</li>'; return;
          }
          if (openList) { body += '</ul>'; openList = false; }
          body += b.k === 'h' ? '<p class="page-label">' + b.v + '</p>' : '<p>' + b.v + '</p>';
        });
        if (openList) body += '</ul>';
        inner = '<div class="page-day">Day ' + num + ' \u2014 free preview</div>' +
          '<h4>' + day.t + '</h4><hr>' + body +
          '<div class="page-one"><b>If you only do one thing:</b> ' + day.one + '</div>';
      } else {
        var link = LINKS[current] || {};
        var cta = link.variantId
          ? '<button class="btn btn-primary btn-sm" data-add="' + link.variantId +
            '" data-add-name="' + prog.name + ' added">Unlock all 30 days \u2014 ' + link.price + '</button>'
          : '<a class="btn btn-primary btn-sm" href="' + (link.url || '#') + '">See the program</a>';
        inner = '<div class="page-day">Day ' + num + ' \u2014 locked</div>' +
          '<h4>' + day.t + '</h4><hr>' +
          '<div class="page-locked"><p>This day is part of the full program. Days 01\u201303 above are ' +
          'the real thing, not a sample \u2014 the remaining 27 unlock the moment you buy.</p>' + cta + '</div>';
      }
      pageEl.innerHTML = chrome + inner + '<div class="page-num">' + day.p + '</div>';
      pageEl.classList.remove('swap'); void pageEl.offsetWidth; pageEl.classList.add('swap');
    }

    if (tabsEl) tabsEl.addEventListener('click', function (e) {
      var b = e.target.closest('.tab'); if (!b) return;
      current = b.dataset.prog; currentDay = 1;
      Array.prototype.forEach.call(tabsEl.querySelectorAll('.tab'), function (t) {
        t.classList.toggle('on', t.dataset.prog === current);
      });
      renderWeeks(); renderPage();
    });

    weeksEl.addEventListener('click', function (e) {
      var b = e.target.closest('.day'); if (!b) return;
      currentDay = Number(b.dataset.day);
      Array.prototype.forEach.call(weeksEl.querySelectorAll('.day'), function (d) {
        d.classList.toggle('on', Number(d.dataset.day) === currentDay);
      });
      renderPage();
    });

    renderWeeks(); renderPage();
  }

  /* ---------------- week arcs on cards / product page ---------------- */
  document.querySelectorAll('[data-arc]').forEach(function (el) {
    var p = window.AURA_CONTENT && window.AURA_CONTENT[el.dataset.arc];
    if (!p) return;
    el.innerHTML = p.weeks.map(function (w, i) {
      return '<li><span class="wk">Wk ' + (i + 1) + '</span><span class="wt">' + w.title + '</span></li>';
    }).join('');
    var spec = document.querySelector('[data-spec="' + el.dataset.arc + '"]');
    if (spec) spec.textContent = p.pages + ' pages \u00b7 30 day pages \u00b7 PDF';
  });

  /* ---------------- faq ---------------- */
  document.querySelectorAll('[data-faq]').forEach(function (list) {
    list.addEventListener('click', function (e) {
      var btn = e.target.closest('.q-btn'); if (!btn) return;
      var q = btn.parentElement, body = q.querySelector('.q-body');
      var wasOpen = q.classList.contains('open');
      list.querySelectorAll('.q').forEach(function (x) {
        x.classList.remove('open');
        x.querySelector('.q-body').style.maxHeight = null;
        x.querySelector('.q-btn').setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        q.classList.add('open');
        body.style.maxHeight = body.scrollHeight + 'px';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ---------------- nav ---------------- */
  var burger = $('burger'), navLinks = $('navLinks');
  if (burger && navLinks) {
    burger.addEventListener('click', function () {
      burger.setAttribute('aria-expanded', String(navLinks.classList.toggle('open')));
    });
    navLinks.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') navLinks.classList.remove('open');
    });
  }

  /* ---------------- sticky buy bar ---------------- */
  var sticky = $('stickybar');
  var hero = document.querySelector('[data-hero]');
  if (sticky && hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) {
      sticky.classList.toggle('on', !e[0].isIntersecting);
    }, { threshold: 0 }).observe(hero);
  }

  /* ---------------- reveals ---------------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (x) {
        if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.rv').forEach(function (el, i) {
      el.style.transitionDelay = (i % 3) * 70 + 'ms';
      io.observe(el);
    });
  } else {
    document.querySelectorAll('.rv').forEach(function (el) { el.classList.add('in'); });
  }
})();
